import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import ArrowIcon from "@/components/icons/ArrowIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ArrowButton',
  props: {
    arrowDirection: {}
  },
  emits: ["clicked"],
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "size-8 md:size-[34px] flex items-center justify-center rounded-full bg-brown hover:bg-active",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked')))
  }, [
    _createVNode(ArrowIcon, {
      class: _normalizeClass(["text-white", {
        '-rotate-[135deg]': props.arrowDirection === 'left',
        'rotate-[135deg]': props.arrowDirection === 'down',
        '-rotate-[45deg]': props.arrowDirection === 'up',
        'rotate-[45deg]': props.arrowDirection === 'right',
      }])
    }, null, 8, ["class"])
  ]))
}
}

})